import applicantSaveService from '@/pages/iebdc/api/apply/applicant-save';
import applicantQlxxService from '@/pages/iebdc/api/apply/applicant-qlxx';
import applyConfig from '@public/applyConfig';
import lodash from 'lodash';
export default {
  data() {
    return {
      config: [], //表单配置
      formModal: {
        children: []
      } //申请表对象
    };
  },
  methods: {
    getProcessInfo(ywh) {
      // 获取流程数据
      return new Promise((resolve, reject) => {
        applicantSaveService.getProcessInfo({ wwywh: ywh }).then((res) => {
          if (res.success) {
            this.config = this.getConfigByCode(res.data.netFlowdefCode);
            if (!this.config) {
              reject('获取配置失败，请在配置文件中配置流程!!!');
            } else {
              applicantQlxxService.setQlxxEx(res.data);
              this.formModal = res.data || {};
              this.formModal.children = this.formModal.children || [{}];
              //转移登记房屋交易价格置为空
              if (this.isNextBtnShow && this.formModal.netFlowdefCode == 'N200104' && this.formModal.children) {
                this.formModal.children.map((item) => {
                  item.qlxxExMhs.map((value) => {
                    this.$set(value, 'fwjyjg', '');
                  });
                });
              }
              //不动产登记证明号获取
              this.formModal.children.map((item) => {
                if (item.bdcdjzmh)
                  item.qlxxExMhs.map((value) => {
                    this.$set(value, 'bdcdjzmh', item.bdcdjzmh);
                  });
              });

              this.arrangeForm(this.formModal.children);
              resolve();
            }
          } else {
            reject(res.message);
          }
        });
      });
    },
    arrangeForm(formModal) {
      const form = {
        qlrs: [],
        ywrs: [],
        qlxxEx: {},
        qlxxExMhs: [],
        tzrxxes: []
      };
      formModal.forEach((formData) => {
        for (let key in form) {
          if (!formData[key]) {
            formData[key] = form[key];
          }
        }
      });
    },
    getConfigByCode(code) {
      const config = applyConfig.find((config) => config.code === code);
      return lodash.cloneDeep(config && config.data);
    }
  }
};
